/** Maps a section background token to its `bg-dep-*` Tailwind class. */
export const sectionBackgroundClasses = {
    default: 'bg-dep-default',
    extraMuted: 'bg-dep-extra-muted',
    muted: 'bg-dep-muted',
    secondary: 'bg-dep-secondary',
    tertiary: 'bg-dep-tertiary',
    yellow: 'bg-dep-yellow',
    pinkLight: 'bg-dep-pink-light',
    pink: 'bg-dep-pink',
    purple: 'bg-dep-purple',
    blue: 'bg-dep-blue',
    green: 'bg-dep-green',
    darkGrey: 'bg-dep-dark-grey',
    grey: 'bg-dep-grey',
};
